import { render, staticRenderFns } from "./KBSmallSelector.vue?vue&type=template&id=630129b7&scoped=true&"
import script from "./KBSmallSelector.vue?vue&type=script&lang=js&"
export * from "./KBSmallSelector.vue?vue&type=script&lang=js&"
import style0 from "./KBSmallSelector.vue?vue&type=style&index=0&id=630129b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630129b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
